import React from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export var WhatsNewLink = function WhatsNewLink(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      link = _ref.link,
      style = _ref.style;

  if (!link.path) {
    return null;
  }

  return /*#__PURE__*/_jsx("a", {
    className: classNames('link-default text-decoration-underline', className),
    href: link.path,
    style: style,
    children: link.title
  });
};